import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import SelectBox from "../../../components/elements/form/selectBox";
import SidebarWOdetails from "./sidebarWOdetails";
import CreateSparePartsModal from "./createSpeareParts.modal";
import toast from "react-hot-toast";
import { useWorkOrderApi } from "../../../store/api/hooks/workOrderApiHook";
import Drawer from "../../../components/Drawer";
import CreateStockpickingSingleWO from "../../Inventory/StockPickingNew/_components/createStockpickingSingleWO";
import CreateStocksModal from "./createStocks.modal";
import Loader from "../../../components/loader";
import EmergencyPartPurchase from "./emergencyPartPurchase";
import Button from "../../../components/elements/button";
import CreatePurchaseRequest from "../../Purchase/Request/_components/createPurchaserequest";
import { useUserSelector } from "../../../store/selectors/userSelector";
import { getPermissionInfo } from "../../../_common/functions";

interface Props {
    workorder?: any;
    onUpdate?: () => void;
    showUsedQty?: boolean;
    disabled?: boolean;
    onPartsChange?: (parts: any[]) => void;
};

const PartlistWOdetails: React.FC<Props> = ({ workorder, onUpdate = () => { }, showUsedQty = false, disabled = false, onPartsChange }) => {

    const params: any = useParams();

    const createSparePartsModalRef: any = useRef();
    const addEmergencyPartRef: any = useRef();
    const divRef = useRef<any>(null);
    const newSPWORef = useRef<any>(null);
    const newSPWOContentRef = useRef<any>(null);
    const partsStockModalRef = useRef<any>(null);
    const createPRref = useRef<any>(null);

    const workOrderAPI: any = useWorkOrderApi();

    const [partsItems, setPartsItems] = useState<any[]>([]);
    const [selectedPartForStock, setSelectedPartForStock] = useState<any>(null);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const loggedinuser: any = useUserSelector();
    const location = useLocation();

    // Log partsItems whenever it changes and notify parent
    useEffect(() => {
        console.log("partsItems updated:", partsItems);
        if (onPartsChange) {
            onPartsChange(partsItems);
        }
    }, [partsItems, onPartsChange]);

    const onOutsideClickx = () => {
        handleOnClickCellEdit()
    }

    const handleOnClickCellEdit = (identifier: string = ``, e: any = null) => {
        if (identifier) {
            const cellElement = document.querySelector(`#${identifier}.editablep`) as HTMLDivElement;
            if (cellElement) {
                const previewElement = cellElement.querySelector(`.preview-value`) as HTMLDivElement;
                const editElement = cellElement.querySelector(`.edit-value`) as HTMLDivElement;
                if (previewElement && editElement) {
                    if (cellElement.id === `${identifier}`) {
                        if (!previewElement.classList.contains(`hidden`)) previewElement.classList.add(`hidden`);
                        if (editElement.classList.contains(`hidden`)) editElement.classList.remove(`hidden`);
                    }
                }
            }
        }
        const editableList = document.querySelectorAll(`.editablep`) as NodeListOf<HTMLDivElement>
        for (let i = 0; i < editableList.length; i++) {
            const editableCell = editableList[i];
            const preview = editableCell.querySelector(`.preview-value`) as HTMLDivElement;
            const edit = editableCell.querySelector(`.edit-value`) as HTMLDivElement;
            if (editableCell.id !== `${identifier}`) {
                if (preview.classList.contains(`hidden`)) preview.classList.remove(`hidden`);
                if (!edit.classList.contains(`hidden`)) edit.classList.add(`hidden`);
            }
        }

    };

    const onSavePartsList = async () => {
        if (partsItems.length === 0) {
            toast.error(`Please add at least one part to the list before saving.`);
            return;
        }
        const payload: any = {
            workOrderID: workorder.workOrderID,
            woSpareParts: partsItems.map((part: any) => {
                return {
                    woSparePartMappingID: part.woSparePartMappingID,
                    sparePartID: part.sparePartID,
                    assetID: part.assetID,
                    requiredQty: part.requiredQty,
                    pickedQty: part.pickedQty,
                    usedQty: part.usedQty,
                    facilityID: part.facilityID,
                    subFaclityID: part.subFaclityID,
                    isPicked: false,
                    isLocked: false,
                }
            })
        };
        setShowLoader(true);
        const savepartresp: any = await new Promise((resolve, reject) => {
            workOrderAPI.SaveWorkOrderInventory(payload, (resp: any) => {
                resolve(resp);
            }, (error: any) => {
                reject(error)
            });
        }).catch((error: any) => {
            toast.error(error?.message || `Failed to save parts list. Please try again.`);
        });
        setShowLoader(false);
        console.log("Save Parts Response: ", savepartresp);
        if (savepartresp && savepartresp.hasOwnProperty('successful') && savepartresp.hasOwnProperty(`code`)) {
            if (savepartresp.successful && savepartresp.code === 200) {
                toast.success(savepartresp.message || `Parts list saved successfully for the Task.`);
                onUpdate();
            } else {
                toast.error(savepartresp.message || `Failed to save parts list. Please try again.`);
            }
        } else {
            toast.error(`Unexpected response from the server while saving parts list.`);
        }
    };

    useEffect(() => {
        if (workorder) {
            if (workorder?.workOrderPartsMappingList && workorder.workOrderPartsMappingList && Array.isArray(workorder.workOrderPartsMappingList) && workorder.workOrderPartsMappingList.length > 0) {
                const bind_parts = workorder.workOrderPartsMappingList.map((part: any) => {
                    return {
                        woSparePartMappingID: part.woSparePartMappingID,
                        sparePartID: part.partsID,
                        assetID: part.assetID,
                        requiredQty: part.requiredQty,
                        pickedQty: part.pickedQty,
                        usedQty: part.usedQty,
                        facilityID: part.facilityID ? part.facilityID : null,
                        subFaclityID: part.subFacilityID ? part.subFacilityID : null,
                        isPicked: false,
                        isLocked: false,

                        partCode: part.partsCode,
                        partName: part.sparePartsName,
                        weightedAvgCost: part.weightedAvgCost || 0
                    };
                });
                console.log("Initial partsItems from workorder:", bind_parts);
                console.log("Original workOrderPartsMappingList:", workorder.workOrderPartsMappingList);
                setPartsItems(bind_parts);
            }
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                onOutsideClickx();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOutsideClickx]);

    useEffect(() => {
        const handleKeyDown = (event: any) => {
            if (event.key === 'Escape') {
                onOutsideClickx();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onOutsideClickx]);

    return (
        <div className="grid grid-cols-1 gap-6 mt-10">
            <div className="pr-4">
                <div className={`flex items-center justify-between mb-3`}>
                    <h4 className="font-semibold text-[0.938rem] py-4">{showUsedQty ? 'Parts Used' : 'Parts Lists'}</h4>
                    {(workorder.woStatusID == 1 || workorder.woStatusID == 2 || workorder.woStatusID == 7 || workorder.woStatusID == 4) && (
                        <div className={`flex items-center gap-2`}>
                            <button  className={`px-4 py-2 rounded text-white ${getPermissionInfo(location.pathname, "Edit", loggedinuser) && !disabled
                                ? "bg-green-700 hover:bg-green-800"
                                : "bg-[#a3bfa3] cursor-not-allowed opacity-70"}`}
                                 disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser) || disabled} 
                                 
                                 onClick={() => {
                                    if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                                        toast.error(`You don't have permission`);
                                        return;
                                    } else {
                                        createSparePartsModalRef?.current?.showModal();
                                    }
                                }}

                                >
                                Add Part from Stock
                            </button>
                            <button
                                className={`px-4 py-2 rounded text-white ${getPermissionInfo(location.pathname, "Purchase Parts In Emergency", loggedinuser) && !disabled
                                    ? "bg-[#8D6E63] hover:bg-[#6d5047]"
                                    : "bg-[#cbb8b3] cursor-not-allowed opacity-70"}`}
                                disabled={!getPermissionInfo(location.pathname, "Purchase Parts In Emergency", loggedinuser) || disabled}
                                onClick={() => {
                                    if (!getPermissionInfo(location.pathname, "Purchase Parts In Emergency", loggedinuser)) {
                                        toast.error(`You don't have permission`);
                                        return;
                                    } else {
                                        addEmergencyPartRef.current?.open();
                                    }
                                }}
                            >
                                Emergency Part Purchase
                            </button>

                            <button className={`px-4 py-2 rounded text-white ${getPermissionInfo(location.pathname, "Edit", loggedinuser) && !disabled
                                ? "bg-[#8D6E63] hover:bg-[#6d5047]"
                                : "bg-[#cbb8b3] cursor-not-allowed opacity-70"}`} disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser) || disabled} onClick={() => {
                                    if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                                        toast.error(`You don't have permission`);
                                        return;
                                    } else {
                                        createPRref.current?.open();
                                    }
                                }}>
                                Part Purchase Request
                            </button>
                        </div>
                    )}
                </div>
                <Drawer _ref={addEmergencyPartRef} isAfterOpenRender={true} onClose={() => { }} outsideClose={false}>
                    <Drawer.Button>
                    </Drawer.Button>
                    <Drawer.Content title='Emergency Part Purchase' className='!w-[54rem]'>
                        <EmergencyPartPurchase wid={workorder.workOrderID} onCreate={() => {
                            addEmergencyPartRef.current.close();
                            onUpdate(); // Refresh the parts list and Task details
                            /* setEditData(null);
                            setCopyData(null)
                            */
                        }} onCancel={() => {
                            addEmergencyPartRef.current.close();
                            /* setEditData(null);
                            setCopyData(null)
                            */
                        }} />
                    </Drawer.Content>
                </Drawer>
                <Drawer _ref={createPRref} isAfterOpenRender={true} onClose={() => {
                }}>
                    <Drawer.Button></Drawer.Button>
                    <Drawer.Content title='New Purchase Request' className='!w-[43rem] !pr-0'>
                        <CreatePurchaseRequest PrID={null} WO={workorder.workOrderID} onCreate={() => {
                            createPRref.current?.close();
                            onUpdate();
                        }} onCancel={() => {
                            createPRref.current?.close();
                        }} />
                    </Drawer.Content>
                </Drawer>
                <CreateSparePartsModal _ref={createSparePartsModalRef} facility={{ label: workorder?.facilityName, value: workorder?.facilityID }} onContinue={(selectedSpareparts: any[]) => {
                    const alreadyaddedparts = selectedSpareparts.filter((part: any) => partsItems.find((item: any) => (+item.sparePartID === +part.partsID)));
                    const freshparts = selectedSpareparts.filter((part: any) => {
                        return partsItems.map((o: any) => +o.sparePartID).indexOf(+part.partsID) < 0
                    });
                    if (alreadyaddedparts.length > 0) {
                        toast.error(`The mention ` + alreadyaddedparts.map((o: any) => o.sparePartsName).join(`, `) + ` already exists in the parts list.`);
                    }
                    partsItems.push(...freshparts.map((part: any) => ({
                        woSparePartMappingID: null,
                        sparePartID: part.partsID,
                        assetID: null,
                        requiredQty: 0,
                        pickedQty: 0,
                        usedQty: 0,
                        facilityID: part.facilityID ? part.facilityID : null,
                        subFaclityID: null,
                        isPicked: false,
                        isLocked: false,

                        partCode: part.partsCode,
                        partName: part.sparePartsName,
                        weightedAvgCost: part.weightedAvgCost || 0

                    })))
                    setPartsItems([...partsItems]);
                    createSparePartsModalRef?.current?.close();
                }} />

                <CreateStocksModal _ref={partsStockModalRef} facility={selectedPartForStock} onContinue={(selectedAssets: any[]) => {
                    partsStockModalRef?.current?.close();
                }} />

                <div>
                    {/* total width 849px */}
                    <div className={`border border-[#043E6133] rounded-[5px] w-full overflow-x-auto  parts-table`}>
                        <div className={`flex items-center flex-nowrap bg-[#F0F0F0] rounded-ss-[5px] rounded-se-[5px]`}>
                            <div className={`w-48 min-w-48 max-w-48 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] flex items-center sticky left-0`}>Part Code</div> {/* 176px */}
                            <div style={{ width: ([1, 2, 7, 4].includes(+workorder.woStatusID) ? (showUsedQty ? `calc(100% - 584px)` : `calc(100% - 448px)`) : (showUsedQty ? `calc(100% - 472px)` : `calc(100% - 336px)`)) }} className={`font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] flex items-center`}>Part Name</div> {/* 270px */}
                            <div className={`w-36 min-w-36 max-w-36 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Required Qty</div> {/* 112px */}
                            {showUsedQty && (
                                <div className={`w-36 min-w-36 max-w-36 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Used Qty</div>
                            )}
                            {showUsedQty && (
                                <div className={`w-36 min-w-36 max-w-36 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-end`}>Value</div>
                            )}

                            {[1, 2, 7, 4].includes(+workorder.woStatusID) && (
                                <div className={`w-28 min-w-28 max-w-28 font-semibold text-[#262A2D] bg-[#F0F0F0] text-[14px] px-2.5 py-2 h-[50px] grow flex items-center justify-center`}></div>
                            )}
                        </div>
                        <div ref={divRef}>
                            {partsItems.length === 0 && (
                                <div className={`flex items-center justify-center h-24 text-gray-500`}>
                                    No parts added yet.
                                </div>
                            )}
                            {partsItems.map((part, index) => (
                                <div className={`flex items-center flex-nowrap`} key={`part-item-${index}`}>
                                    <div className={`w-48 min-w-48 max-w-48 font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex items-center bg-[#F9F9F9] cursor-not-allowed sticky left-0 ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                        <div className={`flex gap-2`}>
                                            {!showUsedQty && (
                                                <svg onClick={() => {
                                                    setSelectedPartForStock({ label: part.partName, value: part.sparePartID });
                                                    //setSpareParts({ label: part?.sparePartsName, value: part?.partsID });
                                                    partsStockModalRef?.current?.showModal();
                                                }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6 text-blue-500 cursor-pointer">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v4m0 4h0m-1-4h1v1h-2V9h1zm3-4c1.5 0 3 1.5 3 3s-1.5 3-3 3s-3-1.5-3-3s1.5-3 3-3zM4 9c0-1.5 1.5-3 3-3s3 1.5 3 3s-1.5 3-3 3s-3-1.5-3-3z" />
                                                </svg>
                                            )}
                                            <div className={``}>{part.partCode || `--`}</div>
                                        </div>

                                    </div>
                                    <div style={{ width: ([1, 2, 7, 4].includes(+workorder.woStatusID) ? (showUsedQty ? `calc(100% - 584px)` : `calc(100% - 448px)`) : (showUsedQty ? `calc(100% - 472px)` : `calc(100% - 336px)`)) }} className={` font-normal text-[#42484B] text-[15px] px-2.5 min-h-12 max-h-12 flex justify-center flex-col bg-[#F9F9F9] cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                        <div className={`preview-value line-clamp-1`} title={part.partName || `--`}>{part.partName || `--`}</div>
                                    </div>

                                    <div className={`w-36 min-w-36 max-w-36 font-normal text-[#42484B] ${showUsedQty ? 'bg-[#F9F9F9] cursor-not-allowed' : 'bg-white'} text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col ${(!showUsedQty && [1, 2, 7, 4].includes(+workorder.woStatusID)) ? `editablep cursor-pointer` : 'cursor-not-allowed'} ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`} id={`part-required-qty-${index}`} onClick={(e: any) => {
                                        if (!showUsedQty) {
                                            handleOnClickCellEdit(`part-required-qty-${index}`, e);
                                            e.stopPropagation();
                                            e.preventDefault();
                                        }
                                    }}>
                                        <div className={`${showUsedQty ? '' : 'preview-value'} text-right`} title={showUsedQty ? '' : ((+part.requiredQty > 0) ? (`Quantity is: ` + part.requiredQty + `, Click here to edit the data`) : `Click here to add data`)}>{part.requiredQty || 0}{/*part.unitCode*/}</div>
                                        {!showUsedQty && (
                                            <div className={`edit-value hidden`}>
                                                <input
                                                    type="tel"
                                                    className={`w-full border border-gray-300 rounded px-2 py-1 outline-none text-right`}
                                                    value={part.requiredQty || 0}
                                                    onChange={(e) => {
                                                        const newQty = +e.target.value;
                                                        const updatedParts = [...partsItems];
                                                        updatedParts[index].requiredQty = isNaN(newQty) ? 0 : newQty;
                                                        setPartsItems(updatedParts);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    {showUsedQty && (
                                        <div className={`w-36 min-w-36 max-w-36 font-normal text-[#42484B] bg-[#F9F9F9] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                            <div className={`text-right`}>{part.usedQty || 0}</div>
                                        </div>
                                    )}
                                    {showUsedQty && (
                                        <div className={`w-36 min-w-36 max-w-36 font-normal text-[#42484B] bg-[#F9F9F9] text-[15px] px-2.5 py-3 min-h-12 max-h-12 flex justify-center flex-col cursor-not-allowed ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                            <div className={`text-right`}>${(part.weightedAvgCost || 0).toFixed(2)}</div>
                                        </div>
                                    )}

                                    {[1, 2, 7, 4].includes(+workorder.woStatusID) && (
                                        <div className={`w-28 min-w-28 max-w-28 font-normal text-[#42484B] bg-white text-[15px] px-2.5 py-3 min-h-12 max-h-12 ${index < (partsItems.length - 1) ? `border-b border-[#043E6133]` : ``}`}>
                                            <div className={`flex items-center justify-center`}>
                                                {(workorder.woStatusID == 1 || workorder.woStatusID == 2 || workorder.woStatusID == 7 || workorder.woStatusID == 4) && (
                                                    <button type="button" className="text-pink-500 hover:text-pink-700 flex items-center justify-center" onClick={() => {
                                                        if (window.confirm("Are you sure you want to remove this spare part?")) {
                                                            //delete part function will call here.
                                                            const updatedParts = [...partsItems];
                                                            updatedParts.splice(index, 1);
                                                            setTimeout(() => {
                                                                setPartsItems(updatedParts);
                                                            });
                                                        }
                                                    }}
                                                    >
                                                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect y="0.5" width="15.0008" height="15" rx="7.5" fill="#E6BDCB" />
                                                            <path d="M10.8974 10.9022C10.93 10.9347 10.9557 10.9733 10.9733 11.0158C10.9909 11.0583 11 11.1038 11 11.1498C11 11.1958 10.9909 11.2413 10.9733 11.2838C10.9557 11.3263 10.93 11.3649 10.8974 11.3974C10.8649 11.43 10.8263 11.4557 10.7838 11.4733C10.7413 11.4909 10.6958 11.5 10.6498 11.5C10.6038 11.5 10.5583 11.4909 10.5158 11.4733C10.4733 11.4557 10.4347 11.43 10.4022 11.3974L7.5 8.49478L4.59779 11.3974C4.53212 11.4631 4.44305 11.5 4.35018 11.5C4.2573 11.5 4.16823 11.4631 4.10256 11.3974C4.03689 11.3318 4 11.2427 4 11.1498C4 11.057 4.03689 10.9679 4.10256 10.9022L7.00521 8L4.10256 5.09779C4.03689 5.03212 4 4.94305 4 4.85018C4 4.7573 4.03689 4.66823 4.10256 4.60256C4.16823 4.53689 4.2573 4.5 4.35018 4.5C4.44305 4.5 4.53212 4.53689 4.59779 4.60256L7.5 7.50521L10.4022 4.60256C10.4679 4.53689 10.557 4.5 10.6498 4.5C10.7427 4.5 10.8318 4.53689 10.8974 4.60256C10.9631 4.66823 11 4.7573 11 4.85018C11 4.94305 10.9631 5.03212 10.8974 5.09779L7.99478 8L10.8974 10.9022Z" fill="#F31260" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}

                        </div>
                    </div>

                    <Drawer _ref={newSPWORef} isAfterOpenRender={true} onClose={() => {
                        newSPWOContentRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button></Drawer.Button>
                        <Drawer.Content title={`Create New Stock Picking for Task`} className='!w-[53rem]'>
                            <CreateStockpickingSingleWO _ref={newSPWOContentRef} editData={null} WOID={workorder.workOrderID} onCreate={() => {
                                onUpdate();
                                newSPWORef?.current?.close();
                            }} onCancel={() => {
                                newSPWORef?.current?.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>

                    {(workorder.woStatusID == 1 || workorder.woStatusID == 2 || workorder.woStatusID === 7 || workorder.woStatusID == 4) && (
                        <>
                            {showLoader ? (
                                <div className={`flex items-center justify-end px-6 py-2 mt-2`}>
                                    <div><Loader /></div>
                                </div>
                            ) : (
                                <div className={`flex items-center justify-end gap-2 mt-4`}>
                                    <button disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser) || disabled} onClick={() => {
                                        if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                                            toast.error(`You don't have permission`);
                                            return;
                                        } else { onSavePartsList(); }

                                    }} type="button" className={`px-4 py-2 rounded text-white ${getPermissionInfo(location.pathname, "Edit", loggedinuser) && !disabled
                                            ? "bg-green-700 hover:bg-green-800"
                                            : "bg-[#a3bfa3] cursor-not-allowed opacity-70"}`}
                                    >
                                        Save
                                    </button>
                                    <button disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser) || disabled} type="button" className={`px-4 py-2 rounded text-white ${getPermissionInfo(location.pathname, "Edit", loggedinuser) && !disabled
                                            ? "bg-green-700 hover:bg-green-800"
                                            : "bg-[#a3bfa3] cursor-not-allowed opacity-70"}`}
                                        onClick={() => {
                                            if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                                                toast.error(`You don't have permission`);
                                                return;
                                            } else {
                                                newSPWORef?.current?.open();
                                            }
                                        }}>
                                        Pick Stock
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PartlistWOdetails;